import { apiClient } from './client';

export interface AvailableData {
  from_date?: string;
  to_date?: string;
}

export interface OrganizationResponse {
  id: number;
  name: string | null;
  active: boolean;
  slug: string;
  time_zone: string;
  parent_id: number | null;
  ref_id: string | null;
  logo_url: string | null;
  dir_name: string | null;
  settings: Record<string, any> | null;
  created_at: string;
  updated_at: string;
  available_data?: AvailableData | null;
}

export interface CreateOrganizationPayload {
  name: string;
  ref_id?: string;
  time_zone?: string;
  logo_url?: string;
  active?: boolean;
  parent_organization_slug?: string;
  settings?: Record<string, any>;
}

export interface UpdateOrganizationPayload {
  name?: string;
  ref_id?: string;
  logo_url?: string;
  active?: boolean;
  parent_organization_slug?: string;
  settings?: Record<string, any>;
}

export const organizationsApi = {
  list: () => apiClient.get<OrganizationResponse[]>('/api/organizations'),

  create: (data: CreateOrganizationPayload) =>
    apiClient.post<OrganizationResponse>('/api/organizations', data),

  update: (slug: string, data: UpdateOrganizationPayload) =>
    apiClient.patch<OrganizationResponse>(`/api/organizations/${slug}`, data),
};
